import { render, staticRenderFns } from "./id-verification.vue?vue&type=template&id=75513fcc&scoped=true"
import script from "./id-verification.vue?vue&type=script&lang=js"
export * from "./id-verification.vue?vue&type=script&lang=js"
import style0 from "./id-verification.vue?vue&type=style&index=0&id=75513fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75513fcc",
  null
  
)

export default component.exports